import { actionsTypes, mutationsTypes } from "./types";

// initial state
const state = () => {
  return {
    product: localStorage.getItem("product")
      ? JSON.parse(localStorage.getItem("product"))
      : null,
  };
};


const actions = {
  [actionsTypes.setProduct]({ commit }, payload) {
    commit(mutationsTypes.SET_PRODUCT, payload.product)
  }


};

const mutations = {
  [mutationsTypes.SET_PRODUCT]: (state, product) => (state.product = product)
};


export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
